import { ApiEpConfig, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import produce from "immer";
import { useQuery, UseQueryOptions } from "react-query";

export const KEY = "ep.config";

type Response = Await<ReturnType<typeof ApiEpConfig.retrieve>>;

export const useEpConfig = (
  options?: Omit<
    UseQueryOptions<Response, FailureApi, Response>,
    "queryFn" | "queryKey"
  >,
) => {
  const { data: config, error } = useQuery<Response, FailureApi, Response>(
    KEY,
    ApiEpConfig.retrieve,
    {
      ...(options || {}),
      select: (data) =>
        produce(data, (draft) => {
          if (draft.story_creator.vk?.video_duration_max_sec === undefined) {
            draft.story_creator.vk = {
              ...(data.story_creator.vk || {}),
              video_duration_max_sec: 14,
            };
          }

          if (draft.story_creator.ok?.video_duration_max_sec === undefined) {
            draft.story_creator.ok = {
              ...(data.story_creator.ok || {}),
              video_duration_max_sec: 59,
            };
          }

          if (
            draft.story_creator.telegram_mtproto?.video_duration_max_sec ===
            undefined
          ) {
            draft.story_creator.telegram_mtproto = {
              ...(data.story_creator.telegram_mtproto || {}),
              video_duration_max_sec: 59,
            };
          }
        }),
    },
  );

  const configFailureApi = error as FailureApi;

  return { config, configFailureApi };
};
